import serverCall from "../../serverCall";

const getAllGroupsList = async (search, page, limit) => {
  try {
    const response = await serverCall.get(
      `/group/admin/get-group?search=${search}&page=${page}&size=${limit}`
    );
    return response;
  } catch (error) {
    console.error("not able to get all groups", error);
  }
};

const getGroupMembers = async (id, search, page, limit) => {
  try {
    const response = await serverCall.get(
      `/group/admin/get-group-members?groupId=${id}&search=${search}&page=${page}&size=${limit}`
    );
    return response;
  } catch (error) {
    console.error("not able to get groupmembers", error);
  }
};

const updatelGroupName = async (id, data) => {
  try {
    const response = await serverCall.patch(
      `/group/admin/update-group?id=${id}`,
      data
    );
    return response;
  } catch (error) {
    console.error("not able to update groupname", error);
  }
};

const deleteGroup = async (id) => {
  const response = await serverCall.delete(
    `/group/admin/delete-group?id=${id}`
  );
  return response;
};

const addNewMemberInGroup = async (groupid, memberId) => {
  const data = {
    groupId: groupid,
    userId: memberId,
  };
  try {
    const response = await serverCall.patch(`/group/add-member-by-admin`, data);
    return response;
  } catch (error) {
    console.error("not able to add member", error);
  }
};

const removeMemberFromGroup = async (groupId, memberId) => {
  const data = {
    groupId: groupId,
    userId: memberId,
  };
  const response = await serverCall.post(`/group/remove-member-by-admin`, data);
  return response;
};

const GroupService = {
  getAllGroupsList,
  updatelGroupName,
  getGroupMembers,
  deleteGroup,
  addNewMemberInGroup,
  removeMemberFromGroup,
};

export default GroupService;
